export default __webpack_public_path__ + "static/media/IMG_1685.ec92b922.jpeg";